import * as firebase from "firebase/app";

export default class FirebaseService {
  private static appInstance: firebase.app.App;

  //todo switch based off Dev/Local and Stage/Prod
  static getAppInstance() {
    console.log("getapp");
    if (FirebaseService.appInstance) {
      return FirebaseService.appInstance;
    }
    if (!firebase.apps.length) {
      console.log("length none");

      let options = {
        apiKey: "AIzaSyCOgpDkOqWI8MHHXsrGJsBlkfkj1hRSxmE",
        authDomain: "shaqfaqs.firebaseapp.com",
        databaseURL: "https://shaqfaqs.firebaseio.com",
        projectId: "shaqfaqs",
        storageBucket: "shaqfaqs.appspot.com",
        messagingSenderId: "573540852202",
        appId: "1:573540852202:web:50a45727721962a9"
      };

      FirebaseService.appInstance = firebase.initializeApp(options);
      console.log("init");

      return FirebaseService.appInstance;
    } else {
      console.log("else");

      FirebaseService.appInstance = firebase.apps[0];
      return FirebaseService.appInstance;
    }
  }

}
